/**
 * C'e' rete? Lo dice il telefono (navigator.onLine).
 *
 * Non e' una garanzia: «in linea» puo' voler dire una tacca sola in un locale
 * tecnico, e la richiesta fallisce lo stesso. Per questo chi manda qualcosa
 * gestisce comunque l'errore; questo serve a non provarci nemmeno quando il
 * telefono SA di non avere rete, e a dirlo con le parole giuste.
 */
export function inLinea(): boolean {
  return typeof navigator === "undefined" || navigator.onLine !== false;
}
